import { createSelector } from 'reselect';
import _get from 'lodash/get';

export const getConditions = state => _get(state, 'stock.data.details.conditions', []);
export const getRewards = state => _get(state, 'stock.data.details.rewards', []);
export const getStockConditionGoods = state => {
  const conditions = getConditions(state);
  return conditions
    .filter(condition => condition.goods)
    .reduce((goods, item) => goods.concat(item.goods), []);
};

export const stockListSelector = createSelector(
  state => _get(state, 'stock.list.data', []),
  list => list,
);

export const stockSelector = createSelector(
  [stockListSelector, (_, alias) => alias],
  (list, alias) => list.find(item => item.alias === alias) || {},
);

export const checkedConditionsSelector = createSelector(getConditions, conditions => {
  return conditions.filter(condition => condition.check);
});

export const progressSelector = createSelector(
  getConditions,
  checkedConditionsSelector,
  (conditions, checkedConditions) => {
    return checkedConditions.length / conditions.length || 0;
  },
);

export const allConditionsCheckedSelector = createSelector(getConditions, conditions =>
  conditions.every(cond => cond.check),
);
